import '@shared/styles/normalize.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'

import App from './App'
import AmplitudeContextProvider from './libs/amplitude/AmplitudeContextProvider'
import { AppModeProvider } from './providers/AppModeProvider'

import '@shared/config/i18n/initI18n'

import '@shared/styles/global.css'
import initApp from '@app/init/initApp'

const queryClient = new QueryClient()

const startApp = async () => {

    await initApp()

    createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <QueryClientProvider client={ queryClient }>
                <BrowserRouter>
                    <AmplitudeContextProvider>
                        <AppModeProvider>
                            <App />
                        </AppModeProvider>
                    </AmplitudeContextProvider>
                </BrowserRouter>
            </QueryClientProvider>
        </StrictMode>,
    )
}

startApp()
